
import { Component, Vue, Prop} from "vue-property-decorator";
import { Datetime } from "vue-datetime";

@Component({
	components: {
		Datetime
	}
})
export default class CustomFieldDatePicker extends Vue {
	@Prop({ type: String, default: null })
	private value: string;

	@Prop({ default: null })
	private model: any;

	@Prop({ type: String, default: null })
	private type: string;

	@Prop({ type: String, default: null })
	private inputClass: string;

	@Prop({ type: Boolean, default: false })
	private readonly: boolean;

	private dateString: string = "";

	private get dateValue(): string {
		if (!this.dateString) {
			this.dateString = this.value;
		}

		return this.dateString;
	}

	private get inputStylingClass(): string {
		if (this.readonly) {
			return "cf-date-input " + this.inputClass + " disabled";
		}
		return "cf-date-input " + this.inputClass;
	}

	private set dateValue(value) {
		this.dateString = value;
	}

	private onChange(): void {
		if (this.dateValue) {
			this.$emit("input", this.dateValue);
		}
	}
}
